import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from '../../../utils/loader/loader.component';
import { ReportsServicesService } from '../../../services/reports-services.service';
import { DevicesService } from '../../../services/devices.service';
import { jwtDecode } from 'jwt-decode';
import { Device } from '../../../models/device';
import { BarChartComponent } from "../../../utils/bar-chart/bar-chart.component";
import { ThemeService } from '../../../theme.service';
import { PieChartComponent } from '../../../utils/pie-chart/pie-chart.component';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-charts',
    imports: [FormsModule, LoaderComponent, BarChartComponent, PieChartComponent, ButtonModule, SelectModule],
    templateUrl: './charts.component.html',
    styleUrl: './charts.component.scss'
})
export class ChartsComponent implements OnChanges {
  loading = false;
  years: any[] = [];
  fromDate!: Date;
  toDate!: Date;
  selectedYear!: number;
  selectedSeason: number = 1;
  selectedReport = 1;
  fromCard = -1;
  toCard = -1;
  configPie: any;
  colorLabels = 'white'
  consumptionsActualYear: any[] = [];
  consumptionsLastYear: any[] = [];
  seasons: any = [{
    value: 1,
    text: 'Mensual'
  },
  {
    value: 2,
    text: 'Bimestral'
  }, {
    value: 3,
    text: 'Trimestral'
  },
  {
    value: 4,
    text: 'Semestral'
  },
  {
    value: 5,
    text: 'Anual'
  },];

  reportTypes: any = [{
    value: 1,
    text: 'Importe'
  },
  {
    value: 2,
    text: 'Volumen'
  }];
  fromDevices = [
    {
      value: -1,
      text: 'Todas'
    },
  ];
  toDevices = [
    {
      value: -1,
      text: 'Todas'
    },
  ];
  loadLastYear = false;
  loadYear = false;
  data: any;
  tokenAuth: any;
  allDevices: Device[] = [];
  fromDateRequest!: Date;
  toDateRequest!: Date;
  fromDateLastRequest!: Date;
  toDateLastRequest!: Date;
  dataSets: any[] = [];
  dataSetPie: any[] = [];
  labelsPie: any[] = [];
  labelsChart: any[] = [];
  chartOptions: any = {
    y: {
      ticks: { color:this.themeService.isDarkEnable?'white':'#4657ec' },
      grid: {
        display: false
      }
    },
    x: {
      ticks: { color:this.themeService.isDarkEnable?'white':'#4657ec' },
      grid: {
        display: false
      }
    }
  };
  darkModeEnabled!: boolean;
  _subscription: any;

  constructor(private service: ReportsServicesService, private deviceService: DevicesService, private themeService: ThemeService, private titleService: Title

  ) {
    this.titleService.setTitle("Gráficas de consumo")
    this.themeService.setTitle("Gráficas de consumos");

    this.data = JSON.parse(localStorage.getItem('data')!);
    this.darkModeEnabled = localStorage.getItem('theme') == "dark" ? true : false;
    this._subscription = themeService.changeTheme.subscribe((value) => {
      this.darkModeEnabled = value;

    });
  }
  ngOnChanges(changes: SimpleChanges): void {

  }


  ngOnInit() {
    if (this.darkModeEnabled) {
      this.colorLabels = 'white';
      this.chartOptions = {
        y: {
          ticks: { color: 'white' },
          grid: {
            display: false
          }
        },
        x: {
          ticks: { color: 'white' },
          grid: {
            display: false
          }
        }
      }

    } else {
      this.colorLabels = 'red';
      this.chartOptions = {
        y: {
          ticks: { color: '#182de7' },
          grid: {
            display: false
          }
        },
        x: {
          ticks: { color: '#182de7' },
          grid: {
            display: false
          }
        }
      }

    }
    this.getAllCards();
    this.addYearsList(3);
    this.getCharts();
  }


  addYearsList(years: number) {
    let today = new Date();
    for (let index = 0; index <= years; index++) {
      if (index == 0) {
        this.selectedYear = today.getFullYear() - index;
        this.fromDate = new Date(today.getFullYear(), 0, 1);
        this.toDate = new Date(today.getFullYear() + 1, 0, 0);
      }

      this.years.push({
        value: today.getFullYear() - index,
        text: (today.getFullYear() - index).toString(),
      });


    }
    this.selectedReport = 1;

  }

  changeYear(event: any) {
    this.selectedYear = event.value;
  }

  changeSeason(event: any) {
    this.selectedSeason = event.value;
  }

  changeReportType(event: any) {
    this.selectedReport = event.value;
  }

  getAllCards() {

    this.deviceService.loadDevices(this.data.Client_number, this.data.User_id, '',true).subscribe({
      next: (resp: any) => {
        this.allDevices = resp;
        resp.forEach((element: any) => {
          this.fromDevices.push({
            value: element.cardId,
            text: (element.cardId.toString().padStart(5, "0")) + ' - ' + element.description
          });
          this.toDevices.push({

            value: element.cardId,
            text: (element.cardId.toString().padStart(5, "0")) + ' - ' + element.description

          });
        });

      },
       error:(error: any)=>{
        this.allDevices = [];        
       }

    })
  }


  changeDeviceFilter(event: any, isFromCard: boolean) {
    if (isFromCard) {
      this.fromCard = event.value;
      this.toDevices = [];
      if (this.fromCard != -1) {

        let filtered = this.allDevices.filter((e: any) => e.cardId >= event.value);
        filtered.forEach(element => {
          this.toDevices.push({
            value: element.cardId,
            text: (element.cardId.toString().padStart(5, "0")) + ' - ' + element.description
          })
        });
        this.toCard = event.value;
      } else {
        this.toDevices = [{
          value: -1,
          text: 'Todas'
        },];
        this.allDevices.forEach(element => {
          this.toDevices.push({
            value: element.cardId,
            text: (element.cardId.toString().padStart(5, "0")) + ' - ' + element.description
          })
        });

        this.toCard = -1;

      }



    } else {
      this.toCard = event.value;
    }
  }

  getPieChart() {

    var cons = this.consumptionsActualYear;
    var totalMagna = 0;
    var totalSupreme = 0;
    var totalDiesel = 0;


    cons.forEach(element => {
      if (element.productCode == 1) {

        totalMagna += this.selectedReport == 1 ? element.amount : element.quantity;

      }
      if (element.productCode == 2) {


        totalSupreme += this.selectedReport == 1 ? element.amount : element.quantity;

      }
      if (element.productCode == 3) {


        totalDiesel += this.selectedReport == 1 ? element.amount : element.quantity;

      }
    });


    this.labelsPie = ["Regular", "Supreme", "Diesel"];
    this.dataSetPie = [
      {
        label: this.selectedYear.toString(),
        data: [totalMagna, totalSupreme, totalDiesel],
        backgroundColor: ["#11b7ee", "#ffd500", "#4657ec"],


      },



    ];




  }
  getCharts() {
    this.loading = true;
    this.consumptionsActualYear = [];
    this.consumptionsLastYear = [];

    this.fromDateRequest = new Date(this.selectedYear, this.fromDate.getMonth(), this.fromDate.getDate());
    this.toDateRequest = new Date(this.selectedYear, this.toDate.getMonth(), this.toDate.getDate());
    this.fromDateLastRequest = new Date(this.fromDateRequest.getFullYear() - 1, this.fromDate.getMonth(), this.fromDate.getDate());
    this.toDateLastRequest = new Date(this.toDateRequest.getFullYear(), 0, 0);


    this.service.getConsumptionsChart(this.data.Client_id, this.fromDateRequest, this.toDateRequest, this.fromCard, this.toCard).subscribe({
      next: (resp: any) => {
        this.service.getConsumptionsChart(this.data.Client_id, this.fromDateLastRequest, this.toDateLastRequest, this.fromCard, this.toCard).subscribe({
          next: (respLY: any) => {
            this.consumptionsLastYear = respLY;
            this.consumptionsActualYear = resp;
            this.loadLastYear = true;
            this.loadYear = true;
            this.loading=false;
            this.loadCharts();
       
          },
          error: (err: any) => {
            this.consumptionsLastYear = [];

          }
        });


      },
      error: (err: any) => {
        this.consumptionsActualYear = [];
        this.consumptionsLastYear = [];

      }
    });

    this.service.getConsumptionsChart(this.data.Client_id, this.fromDateLastRequest, this.toDateLastRequest, this.fromCard, this.toCard).subscribe({
      next: (resp: any) => {
        this.consumptionsLastYear = resp;
        this.loadLastYear = true;
        this.loadCharts();
      },
      error: (err: any) => {
        this.consumptionsLastYear = [];

      }
    });

  }

  loadCharts() {
    this.getPieChart();
    this.setDataChart();
  }
  setDataChart() {
    var consumptions = this.consumptionsActualYear;
    var lastYearConsumptions = this.consumptionsLastYear;
    this.dataSets = [];
    let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    var dataChartActual: any = {
      label: this.fromDateRequest.getFullYear(),
      data: [],
      fill: true,
      borderColor: "#f8f8f8",

      tension: 0.5,
      pointStyle: "bar",
      backgroundColor: ["#4657ec"],
      borderColors: ["#4657ec "],
      borderRadius: 8
    };
    var dataChartLast: any = {
      label: this.fromDateLastRequest.getFullYear(),
      data: [],
      fill: true,
      borderColor: "#f8f8f8",

      tension: 0.5,
      pointStyle: "bar",
      backgroundColor: ["#ffd500"],
      borderColors: ["#ffd500 "],
      borderRadius: 8
    };
    switch (this.selectedSeason) {
      case 1:
        let noMonths = 12;
        this.labelsChart = meses;

        for (var i = 1; i <= meses.length; i++) {
          var cons = consumptions.find((con: any) => con.month == i);
          var consLast = lastYearConsumptions.find((con: any) => con.month == i);

          if (cons) {
            dataChartActual.data[i - 1] = this.selectedReport == 1 ? cons.amount : cons.quantity;

          } else {
            dataChartActual.data[i - 1] = 0;
          }

          if (consLast) {
            dataChartLast.data[i - 1] = this.selectedReport == 1 ? consLast.amount : consLast.quantity;
          }
          else {
            dataChartLast.data[i - 1] = 0
          }



        }
        this.dataSets.push(dataChartLast);
        this.dataSets.push(dataChartActual);
      
        break;
      case 2:
        var noPeriods = 6;

        var labels = [];

        var pos = 0;

        for (var i = 1; i < meses.length + 1; i = i + 2) {


          labels.push(meses[i - 1] + ' / ' + meses[i]);
          var consActual = consumptions.find((con: any) => con.month == i);
          var consAnterior = consumptions.find((con: any) => con.month == i - 1);
          var consLastActual = lastYearConsumptions.find((con: any) => con.month == i);
          var consLastAnterior = lastYearConsumptions.find((con: any) => con.month == i - 1);


          if (consAnterior) {
            if (consActual) {
              dataChartActual.data[pos] = this.selectedReport == 1 ? (consAnterior.amount + consActual.amount) : (consAnterior.quantity + consActual.quantity);
             
            } else {
              dataChartActual.data[pos] = this.selectedReport == 1 ? consAnterior.amount : consAnterior.quantity;
              
            }
          } else {
            if (consActual) {
              dataChartActual.data[pos] = this.selectedReport == 1 ? consActual.amount : consActual.quantity;
              
            } else {
              dataChartActual.data[pos] = 0;
              
            }
          }

          if (consLastAnterior) {
            if (consLastActual) {
              
              dataChartLast.data[pos] = this.selectedReport == 1 ? (consLastAnterior.amount + consLastAnterior.amount) : (consLastAnterior.quantity + consLastAnterior.quantity);
            } else {
              
              dataChartLast.data[pos] = this.selectedReport == 1 ? consLastAnterior.amount : consLastAnterior.quantity;
            }
          } else {
            if (consLastActual) {
              
              dataChartLast.data[pos] = this.selectedReport == 1 ? consLastActual.amount : consLastActual.quantity;
            } else {
              
              dataChartLast.data[pos] = 0;
            }
          }
          pos++;

        }
        this.labelsChart = labels;
        this.dataSets.push(dataChartLast);
        this.dataSets.push(dataChartActual);
      
        break;


      case 3:
        var noPeriods = 3;
        
        var labels = [];

        var pos = 0;
        
        for (var i = 2; i < meses.length; i = i + 3) {
          labels.push(meses[i - 2] + ' / ' + meses[i]);
          if (i == 2) {
            var first = consumptions.find((con: any) => con.month == i);
            var second = consumptions.find((con: any) => con.month == i - 1);
            var third = consumptions.find((con: any) => con.month == i - 2);

            var firstLast = lastYearConsumptions.find((con: any) => con.month == i);
            var secondLast = lastYearConsumptions.find((con: any) => con.month == i - 1);
            var thirdLast = lastYearConsumptions.find((con: any) => con.month == i - 2);
          } else {
            var first = consumptions.find((con: any) => con.month == i + 1);
            var second = consumptions.find((con: any) => con.month == i);
            var third = consumptions.find((con: any) => con.month == i - 1);

            var firstLast = lastYearConsumptions.find((con: any) => con.month == i + 1);
            var secondLast = lastYearConsumptions.find((con: any) => con.month == i);
            var thirdLast = lastYearConsumptions.find((con: any) => con.month == i - 1);
          }

          if (this.selectedReport == 1) {
            var suma = (first ? first.amount : 0) + (second ? second.amount : 0) + (third ? third.amount : 0);
            var sumaLast = (firstLast ? firstLast.amount : 0) + (secondLast ? secondLast.amount : 0) + (thirdLast ? thirdLast.amount : 0);
          } else {
            var suma = (first ? first.quantity : 0) + (second ? second.quantity : 0) + (third ? third.quantity : 0);
            var sumaLast = (firstLast ? firstLast.quantity : 0) + (secondLast ? secondLast.quantity : 0) + (thirdLast ? thirdLast.quantity : 0);
          }


          dataChartActual.data[pos] = suma;
          dataChartLast.data[pos] = sumaLast;
          pos++;

        }
        this.labelsChart = labels;
        this.dataSets.push(dataChartLast);
        this.dataSets.push(dataChartActual);
      



        break;
      case 4:
        var labels = [];

        var pos = 0;
        var sumaActual = 0;
        var sumaLastSem = 0;
        for (var i = 0; i < meses.length; i = i + 6) {

          labels.push(meses[i] + ' / ' + meses[i + 5]);

          for (var j = 0; j <6; j++) {
            let mesBusq=i+j+1;
            var conMonth = consumptions.find((con: any) => con.month == mesBusq);
          
            var conLastMonth = lastYearConsumptions.find((con: any) => con.month == mesBusq);
            if (conMonth != undefined) {
              sumaActual += this.selectedReport == 1 ? conMonth.amount : conMonth.quantity;
            } else {
              sumaActual += 0;
            }
            if (conLastMonth != undefined ||  conLastMonth!=null) {
              sumaLastSem += this.selectedReport == 1 ? conLastMonth.amount : conLastMonth.quantity;
            } else {
              sumaLastSem += 0;
            }
          }
          
          dataChartActual.data[pos] = sumaActual;
          dataChartLast.data[pos] = sumaLastSem;

          pos++


        }

       
        this.labelsChart = labels;
        this.dataSets.push(dataChartLast);
        this.dataSets.push(dataChartActual);
       
        break;
      case 5:
        var labels = [];

        var pos = 0;
        var sumaActual = 0;
        var sumaLastYear = 0;
        labels.push(this.fromDateLastRequest.getFullYear());
        labels.push(this.fromDateRequest.getFullYear());
        for (var i = 0; i < meses.length; i++) {

          var conMonth = consumptions.find((con: any) => con.month == i);
          var conLastYearMonth = lastYearConsumptions.find((con: any) => con.month == i);

          if (conMonth) {
            sumaActual += conMonth.amount;
          } else {
            sumaActual += 0;
          }

          if (conLastYearMonth) {
            sumaLastYear += conLastYearMonth.amount;
          } else {
            sumaLastYear += 0;
          }

        }

        dataChartActual.data[1] = sumaActual;
        dataChartLast.data[0] = sumaLastYear;
        this.labelsChart = labels;
        this.dataSets.push(dataChartLast);
        this.dataSets.push(dataChartActual);
        break;

      default:
        break;
    }
  }
}
